import React from "react"
import { Link } from "gatsby"
import { MdEmail } from 'react-icons/md';
import { FiCode } from 'react-icons/fi';

import { Navbar, Nav, Form, FormControl, Button, Container } from "react-bootstrap"

const CustomNavbar = ({ pageInfo }) => {
  return (
    <>
      <Navbar expand="sm">
        <Container>
        <Navbar.Brand href="/">serpa.codes <FiCode/></Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className='ml-auto'>
            <Nav.Link href="https://linkedin.com/in/fullofcaffeine">LinkedIn</Nav.Link>
            <Nav.Link href="https://github.com/fullofcaffeine">GitHub</Nav.Link>
            <Nav.Link href="https://twitter.com/fullofcaffeine">Twitter</Nav.Link>
            <Nav.Link href="mailto:hello@fullofcaffeine.co?subject=I'm interested in hiring you, please send me your resume">Resume</Nav.Link>
          </Nav>
        </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  )
}

export default CustomNavbar
